const navicon = document.querySelector('#nav-icon');
const overflowY = document.querySelector('.overflowY');
const body = document.querySelector('body');
navicon.addEventListener('click', function (e) {
	navicon.classList.toggle('open');
	overflowY.classList.toggle('open');
	body.classList.toggle('open');
	const blogs = document.querySelector('#mobileInsights.empty');
	if (blogs !== null) {
		fetch('/hubspot2.php')
		.then((response) => response.json())
		.then((result) => {
			result.objects.forEach((blog) => {
				const blogList = document.createElement('div');
				blogList.classList.add('blog')
				blogList.innerHTML = `
				<figure>
					<a href="${blog.published_url}" target="_blank" tabindex="0">
						<img src="${blog.featured_image}" alt="${blog.name}" width="420" height="220" loading="lazy">
					</a>
				</figure>
				<div class="blogMeta">
					<h3 class="wp-block-heading has-text-color has-link-color has-black-color has-body-large-font-size"><a href="${blog.published_url}" target="_blank" class="has-text-color has-link-color has-black-color" tabindex="0"><strong>${blog.name}</strong></a></h3>
					<p class="arrowlink hollow"><a href="${blog.published_url}" title="Read ${blog.name}">Read article</a></p>
				</div>`
				blogs.appendChild(blogList);
				blogs.classList.remove('empty');
			})
		})
		.catch((error) => console.error(error));
	}
});

